export default __webpack_public_path__ + "static/media/security-details-generate-sales-report.beed4b5a.svg";